import { render, staticRenderFns } from "./QuienSomos.vue?vue&type=template&id=d5a1da72&"
import script from "./QuienSomos.vue?vue&type=script&lang=js&"
export * from "./QuienSomos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports